
import Vue from 'vue';
import ConfiguratorCategoryContainer from '@/components/ConfiguratorCategoryContainer.vue'
import ConfiguratorMobileSubcategoryCollapse from '@/components/mobile/ConfiguratorMobileSubcategoryCollapse.vue'
import ConfiguratorMobileCategoryHeading from '@/components/mobile/ConfiguratorMobileCategoryHeading.vue'
import * as categories from '../colors/componentCategories'
import store from '../store';
import { Perspective } from '@/types/Perspective';

export default Vue.extend({
  name: 'ConfiguratorContainer',
  components: {
      ConfiguratorCategoryContainer,
      ConfiguratorMobileSubcategoryCollapse,
      ConfiguratorMobileCategoryHeading
  },
  store,
  data() {
      return {
          gehauseSubcategory: categories.gehauseSubcategory,
          zifferBlattSubCategory: categories.zifferBlattSubCategory,
          rueckseiteCategory: categories.rueckseiteCategory,
          bandCategory: categories.bandCategory,
          isMobile: false,
          chosenSubCategory: undefined
      }
  },
  mounted() {
    this.handleResize();
    window.addEventListener('resize', this.handleResize);
  },
  destroyed() {
    window.removeEventListener('resize', this.handleResize);
  },
  computed: {
    showHeading(): boolean {
      if (this.isMobile) {
        return false
      }
      if (window.screen.height > 450) {
        return true
      }
      return false
    }
  },
  methods: {
      showBack() {
          this.$store.commit('setPerspective', Perspective.BACK)
      },
      showFront() {
          this.$store.commit('setPerspective', Perspective.FRONT)
      },
      handleResize() {
      this.isMobile = window.screen.width < 666;
    }
  }
});
